import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { NamePath } from 'antd/es/form/interface'
import { EditableCellCtx } from '../editable-cell'

interface VirtualStampFloodsProps {
    dataIndex?: NamePath
}

const VirtualStampFloods: FC<VirtualStampFloodsProps> = ({ dataIndex }) => {
    const ctx = useContext(EditableCellCtx)

    return (
        <Form.Item name={dataIndex ?? ['virtualStamp', 'floods']} noStyle>
            <InputNumber autoFocus controls={false} onBlur={() => ctx.onBlur()} />
        </Form.Item>
    )
}

export default VirtualStampFloods
